import React from "react";
import "./ModalComponent.css";
import Modal from "react-modal";

Modal.defaultStyles.overlay.backgroundColor = "rgb(0, 0, 0, 0.5)";

const ModalComponent = (props) => {

  const {
    modalBody,
    buttonText,
    handleClose,
    isModalOpen,
    modalHeading,
    handleConfirm,
    widthContainer,
  } = props;

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      padding: "0px",
      overflow: "hidden",
      borderRadius: "0px",
      transform: "translate(-50%, -50%)",
      width: widthContainer,
    },
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isModalOpen}
      style={customModalStyles}
      onRequestClose={() => handleClose()}
    >

      <div className="modal-component-header-wrapper">
        <div className="modal-component-header"> {modalHeading} </div>
        <div onClick={() => handleClose()} className="modal-component-close">
          X
        </div>
      </div>

      <div className="modal-component-body-wrapper">
        {modalBody}
      </div>

      <div className="modal-component-button-wrapper modal-component-fonts">
        <div
          onClick={() => handleClose()}
          className="modal-component-cancel-button modal-component-buttons" 
        >
          Cancel
        </div>
        <div
          onClick={() => handleConfirm()}
          className="modal-component-confirm-button modal-component-buttons" 
        >
          {buttonText}
        </div>
      </div>

    </Modal>
  );
};

export default ModalComponent;
